import { useEffect, useRef } from 'react';

export const useOutsideClick = (handler, attached = true) => {
    const outsideRef = useRef(null);

    useEffect(() => {
        if (!attached) return;

        const handleClickOutside = (e) => {
            if (outsideRef.current && !outsideRef.current.contains(e.target)) {
                handler();
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [handler, attached]);

    return outsideRef;
};
